@if (show && isLoading) {
  <div class="inline" data-cy="file-manager-image-loading">
    @if (height) {
      <img
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-height.px]="height"
        src="assets/Images/defaultPatient.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-loading-height" />
    }
    @if (width) {
      <img
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-width.px]="width"
        src="assets/Images/defaultPatient.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-loading-width" />
    }
  </div>
}
@if (show && !isLoading && sanitizedURL && isImage) {
  <div class="inline" data-cy="file-manager-image-image">
    @if (height && !maxWidth) {
      <img
        [style.max-height.px]="height"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [src]="sanitizedURL | secureImage | async"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-height" />
    }
    @if (width && !maxHeight) {
      <img
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-width.px]="width"
        [src]="sanitizedURL | secureImage | async"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-width" />
    }
    @if (height && maxWidth && !width) {
      <img
        [style.max-width.px]="maxWidth"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-height.px]="height"
        [src]="sanitizedURL | secureImage | async"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-height-max-width" />
    }
    @if (width && maxHeight) {
      <img
        [style.max-width.px]="width"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-height.px]="maxHeight"
        [src]="sanitizedURL | secureImage | async"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-width-max-height" />
    }
  </div>
}
@if (show && !isLoading && sanitizedURL && !isImage) {
  <div class="inline" data-cy="file-manager-image-file">
    @if (height && !maxWidth) {
      <img
        [style.max-height.px]="height"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        src="assets/Images/File.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-file-height" />
    }
    @if (width && !maxHeight) {
      <img
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-width.px]="width"
        src="assets/Images/File.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-file-width" />
    }
    @if (height && maxWidth) {
      <img
        [style.max-width.px]="maxWidth"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-height.px]="height"
        src="assets/Images/File.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-file-height-max-width" />
    }
    @if (width && maxHeight) {
      <img
        [style.max-width.px]="width"
        [class.roundcorners]="roundCorners" [class.round]="roundImage"
        [style.max-height.px]="maxHeight"
        src="assets/Images/File.PNG"
        (error)="show = false; markDocumentAsDeleted()"
        class="file-preview-image"
        data-cy="file-manager-image-file-width-max-height" />
    }
  </div>
}

<!-- Kind of a lazy way to do this -->
@if (fillParentWidth && !isLoading && sanitizedURL) {
  <div class="inline w-100" data-cy="file-manager-image-fill-width">
    <img [class.roundcorners]="roundCorners" [class.round]="roundImage"
      style="background-size:contain"
      [src]="sanitizedURL | secureImage | async"
      (error)="show = false; markDocumentAsDeleted()"
      class="file-preview-image w-100"
      data-cy="file-manager-image-fill-width-img" />
    </div>
  }

  @if (resizable && !isLoading && sanitizedURL) {
    <div class="inline" data-cy="file-manager-image-resizable">
      <img [src]="sanitizedURL | secureImage | async" class="w-100 h-100" data-cy="file-manager-image-resizable-img" />
    </div>
  }
